<template>
  <v-dialog v-model="isDialogOpen" max-width="1400" :activator="null">
    <InstallPWAMobileWizard
      :os="isIOS() ? 'ios' : 'android'"
      @close="isDialogOpen = false"
      v-if="isMobileDevice()"
      :key="dialogKey"
    >
    </InstallPWAMobileWizard>
    <InstallPWADesktopWizard
      :key="dialogKey"
      v-else
      @close="isDialogOpen = false"
    >
    </InstallPWADesktopWizard>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import InstallPWADesktopWizard from "features/push/InstallPWADesktopWizard.vue"
import InstallPWAMobileWizard from "features/push/InstallPWAMobileWizard.vue"
import { isIOS } from "features/push/concerns/platform"

export default defineComponent({
  name: "InstallPWADialog",
  components: { InstallPWAMobileWizard, InstallPWADesktopWizard },
  data() {
    return {
      isDialogOpen: false,
      dialogKey: 0,
    }
  },
  watch: {
    "$route.params": {
      handler() {
        if (window.location.hash === "#pwa-install") {
          this.openWizard()
        }
      },
      deep: true,
      immediate: true,
    },
    isDialogOpen(newVal) {
      window.location.hash = newVal ? "#pwa-install" : ""
    },
  },
  methods: {
    openWizard() {
      this.dialogKey++
      this.isDialogOpen = true
    },
  },
  setup() {
    function isMobileDevice() {
      if (!("navigator" in window)) {
        return false
      }
      const userAgent = navigator.userAgent.toLowerCase()
      const mobileKeywords = [
        "mobile",
        "iphone",
        "ipod",
        "android",
        "blackberry",
        "windows phone",
      ]

      for (let i = 0; i < mobileKeywords.length; i++) {
        if (userAgent.indexOf(mobileKeywords[i]) !== -1) {
          return true // Client is a mobile device
        }
      }

      return false // Client is not a mobile device
    }
    return {
      isMobileDevice,
      isIOS,
    }
  },
})
</script>
